import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Checkbox } from '@ps-design-system/components/Checkbox';

import PauseToggle from './PauseToggle';
import PauseModalTitle from './PauseModalTitle';

const EndPauseModalHost = ({ isToggled, handleToggle, isChecked, handleChecked }) => {
  return (
    <div className="end-pause-modal">
      <PauseModalTitle isToggled={isToggled} />
      <div>
        <Text typeface="body-2" >
          <FormattedMessage id="pause.modal.reactivating" defaultMessage="By reactivating your space on Peerspace, you agree to:"/>
        </Text>
      </div>
      <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
        <li>
          <Text typeface="body-2" >
            <FormattedMessage id="pause.modal.transactions" defaultMessage="Keep all booking transactions on the Peerspace platform"/>
          </Text>
        </li>
        <li>
          <Text typeface="body-2" >
            <FormattedMessage id="pause.modal.respond" defaultMessage="Respond promptly to inquiries and maintain reliable booking performance"/>
          </Text>
        </li>
        <li>
          <Text typeface="body-2" >
            <FormattedMessage id="pause.modal.calendar" defaultMessage="Keep your calendar and listing details accurate and up-to-date"/>
          </Text>
        </li>
      </ul>
      <PauseToggle isEndPause toggle={isToggled} onToggle={handleToggle} attributes={{ 'data-testing-id': 'pause-modal-toggle' }} />
      <Checkbox
        alignment="top"
        onCheckedChange={handleChecked}
        checked={isChecked}
        description={
          <>
            <Text
              typeface="body-2"
              style={{ textTransform: 'none' }}
            >
              <FormattedMessage id="pause.modal.understand" defaultMessage="I understand that failure to meet Peerspace performance and community standards may result in my listings being removed or my account being terminated."/>
              {' '}
              <a href="https://support.peerspace.com/en/articles/11380453-host-performance-guide" target="_blank" rel="noopener noreferrer" className='end-pause-link'><FormattedMessage id="pause.modal.learn" defaultMessage="Learn more about Host Performance Standards" /></a>
            </Text>
          </>
        }
      />
    </div>
  );
};

EndPauseModalHost.propTypes = {
  isChecked: PropTypes.bool,
  handleChecked: PropTypes.func,
  isToggled: PropTypes.bool,
  handleToggle: PropTypes.func
};

EndPauseModalHost.defaultProps = {
  isChecked: false,
  handleChecked: () => {},
  isToggled: false,
  handleToggle: () => {}
};

export default EndPauseModalHost;
